import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-h', 'LetterH', [["path",{"d":"M9 7v5m0 0v5m0-5h6.25m0-5v5m0 0v5","key":"svg-0"}]]);